import React from "react";
import "./Loading.css";

const LodingCirlce = ({ pending = false }) => {
  return (
    <div
      className="loadin-main-box"
      style={pending ?{ display: "flex" } : { display: "none" }}
    >
        

     
        
      {pending && <div class="custom-loader"></div>}
   
    </div>
  );
};

export default LodingCirlce;
